import { render } from "./ElearningFormationPage.vue?vue&type=template&id=37bf1c8c&scoped=true"
import script from "./ElearningFormationPage.vue?vue&type=script&lang=js"
export * from "./ElearningFormationPage.vue?vue&type=script&lang=js"

import "./ElearningFormationPage.vue?vue&type=style&index=0&id=37bf1c8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bf1c8c"]])

export default __exports__